import React from 'react'
import PropTypes from 'prop-types'
import arraySort from 'array-sort'
import ContentWarningItem from './ContentWarningItem'
import { mapContentWarnings } from '../../../../utils/contentwarnings'

const ContentWarningsList = props => {
  const mappedContentWarnings = mapContentWarnings(props.contentWarnings)
  const sortedContentWarnings = arraySort(mappedContentWarnings, ['sort_order'])
  const contentWarnings = sortedContentWarnings.map(cw => (
    <ContentWarningItem contentWarning={cw} key={cw.text} />
  ))
  return <ul>{contentWarnings}</ul>
}

ContentWarningsList.propTypes = {
  contentWarnings: PropTypes.object.isRequired
}

export default ContentWarningsList



// WEBPACK FOOTER //
// ./src/components/quest/basicinformation/contentwarnings/ContentWarningsList.js